import React from 'react';
import Metrics from 'services/metrics';

class FacebookLogin extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    (function(d, s, id) {
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    window.fbAsyncInit = () => {
      FB.init({
        appId: this.props.socialId,
        xfbml: this.props.xfbml,
        cookie: this.props.cookie,
        version: this.props.version,
      });
    };
  }

  responseApi(authResponse) {
    FB.api('/me', { fields: this.props.fields }, me => {
      me.accessToken = authResponse.accessToken;
      this.props.responseHandler(me);
    });
  }

  checkLoginState(response) {
    if (response.authResponse) {
      this.responseApi(response.authResponse);
    } else if (this.props.responseHandler) {
      this.props.responseHandler({ status: response.status });
    }
  }

  clickHandler() {
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Redes Sociales',
      eventLabel: 'Vincular',
    });
    FB.login(this.checkLoginState.bind(this), { scope: this.props.scope });
  }

  render() {
    return (
      <div>
        <button
          className={this.props.class}
          onClick={this.clickHandler.bind(this)}
        >
          <i className="fa fa-facebook padding-right-1" />
          {this.props.buttonText}
        </button>
      </div>
    );
  }
}

export { FacebookLogin };
